import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../swzutils";
const IndustrySelect = ({ value, onChange }) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const loadIndustries = () => {
        setLoading(true);
        axios.get('/admin/v1/tenants/registrations/industries').then(response => {
            const options = response.data
                .sort((a, b) => {
                if (a.description > b.description)
                    return 1;
                if (a.description < b.description)
                    return -1;
                return 0;
            })
                .map((category) => {
                return {
                    label: category.description,
                    value: category.name
                };
            });
            setOptions(options);
        })
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    useEffect(() => {
        loadIndustries();
    }, []);
    return (_jsx(Select, { placeholder: "Industry", showSearch: {
            optionFilterProp: ['label']
        }, value: value, loading: loading, onChange: onChange, options: options }));
};
export default IndustrySelect;
